import React from 'react';
import PropTypes from 'prop-types';
// styles
import './Style/Style.css';
// assets
import pellaLogo from '../../assets/pella_logo.png';

// needs height to be passed as prop to align the logo and text in the center
const BouncingLogo = ({ height, text, zIndex }) => {
  return (
    <div
      style={{
        animation: 'bounce 2s infinite',
        textAlign: 'center',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        height: height,
        zIndex: zIndex,
      }}
    >
      <img src={pellaLogo} title="Pella Logo" alt="Pella Logo" height={'88px'} width={'88px'} />
      <div style={{ color: 'black', marginTop: '20px', fontSize: '20px', fontStyle: 'italic' }}>
        {text}
      </div>
    </div>
  );
};

export default BouncingLogo;

BouncingLogo.propTypes = {
  height: PropTypes.string,
  text: PropTypes.string,
  zIndex: PropTypes.number,
};
